import type React from "react";

import { useDispatch } from "react-redux";

import type { LeadsSearchRow } from "app/pages/sales-intelligence/modules/leads-search";
import { CompanyContactsCell } from "app/pages/sales-intelligence/modules/leads-search/components/cells/CompanyContactsCell/CompanyContactsCell";
import { getMainCompanyDomainOrDefault } from "app/pages/sales-intelligence/modules/leads-search/utils/rows";
import {
    setIsFiltersPanelExpanded,
    updateLeadsFilterValue,
} from "app/pages/sales-intelligence/modules/leads-search-filters/store/action-creators";
import { setActivePageTab } from "app/pages/sales-intelligence/sub-modules/common/store/action-creators";

import trackingService from "../../../services/tracking/trackingService";

type Props = {
    contactCount: number | null;
    record: LeadsSearchRow;
};

export const CompanyContactsCellContainer: React.FC<Props> = ({ contactCount, record }) => {
    const dispatch = useDispatch();

    const domain = getMainCompanyDomainOrDefault(record).domain;

    const handleClick = () => {
        dispatch(setIsFiltersPanelExpanded(true));
        dispatch(setActivePageTab("contacts"));
        dispatch(updateLeadsFilterValue({ contactsFilters: { companyDomains: [domain] } }));
        trackingService.trackCompanyContactsClick(record.company ?? "", contactCount ?? 0);
    };

    return (
        <CompanyContactsCell
            onClick={handleClick}
            contactCount={contactCount}
        />
    );
};
